// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"24a24da7","656":"24a24da7"}[chunkId] + ".chunk.css";
};